import { render, staticRenderFns } from "./project_fee.vue?vue&type=template&id=5fda3d1e&scoped=true&"
import script from "./project_fee.vue?vue&type=script&lang=js&"
export * from "./project_fee.vue?vue&type=script&lang=js&"
import style0 from "./project_fee.vue?vue&type=style&index=0&id=5fda3d1e&scoped=true&lang=less&"
import style1 from "./project_fee.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda3d1e",
  null
  
)

export default component.exports